import React, { useState } from 'react';

// hooks
import { useActiveUser } from 'shared/hooks/use-active-user';

// components
import { Button } from 'shared/components/bulma/button';
import { Modal, ModalContent, ModalControl } from 'shared/components/bulma/modal';

// helper
import * as helper from './helper';

const AddCommentModal = ({ isActive, onDismiss, onSubmit }) => {
    const [comment, setComment] = useState('');

    const handleChange = async (event) => {
        const { value } = event.target;
        setComment(value);
    }

    const SubmitButton = () => {
        if (comment.trim()) {
            return <Button onClick={() => onSubmit(comment)} className="is-primary">Add</Button>
        }

        return null;
    }

    return (
        <Modal title="Add Comment" isActive={isActive}>
            <ModalContent>
                <textarea className="textarea has-fixed-size" placeholder="Type to add comment" onChange={handleChange}></textarea>
            </ModalContent>
            <ModalControl>
                <SubmitButton />
                <Button onClick={onDismiss}>Cancel</Button>
            </ModalControl>
        </Modal>
    );
}

const AddComment = ({ customer, onAdd }) => {

    const user = useActiveUser();
    const [isActive, setActive] = useState(false);

    const handleClick = async () => {
        setActive(true);
    }

    const dismiss = () => {
        setActive(false);
    }

    const add = async (comment) => {
        const payload = { content: comment, timestamp: new Date(), author: user.ref };
        await helper.handleAddComment(payload, customer.id);

        if (onAdd) { onAdd(payload); }
    }

    const Modal = () => {
        if (!isActive) {
            return null;
        }

        return (
            <AddCommentModal isActive={true} onSubmit={add} onDismiss={dismiss} />
        );
    }

    return (
        <>
            <Button className="is-small is-dark is-outlined" onClick={handleClick} >
                <span className="icon">
                    <i className="fas fa-plus-square"></i>
                </span>
                <span>Add Comment</span>
            </Button>

            <Modal />
        </>
    );
}

export { AddComment };
